import { useEffect } from 'react';
import { SelectValue } from '../../../Components/Base/Select/Select';

export default function useSelectValueGuard({
	value,
	options,
	onChange,
}: {
	value?: string | number | SelectValue;
	options: SelectValue[];
	onChange?: (value: SelectValue) => void;
}) {
	useEffect(() => {
		if (value !== null && value !== undefined) {
			if (typeof value === 'object' && !value.label) {
				if (
					typeof value.value === 'string' ||
					typeof value.value === 'number'
				) {
					value = value.value;
				}
			}
			if (typeof value === 'string' || typeof value === 'number') {
				if (typeof value === 'number') {
					value = value.toString();
				}
				const newValue = options?.find(item => item.value === value);
				if (newValue) {
					onChange?.(newValue);
				}
			}
		}
	}, [options, value]);
}
